(function () {
  'use strict';

  if (window.ChicSewMobileSwatchRecovery) return;
  window.ChicSewMobileSwatchRecovery = true;

  var closeTimer = null;
  var scrollTimer = null;

  function isMobileViewport() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function clearStaleScrollLocks() {
    document.documentElement.style.removeProperty('overflow');
    document.documentElement.style.removeProperty('overflow-y');
    document.documentElement.style.removeProperty('touch-action');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('overflow-y');
    document.body.style.removeProperty('touch-action');
  }

  function closeMobileSwatches() {
    document.querySelectorAll('.product-shop .swatch.active-swatch').forEach(function (swatch) {
      swatch.classList.remove('active-swatch');
    });
    document.querySelectorAll('.overlay.active-overlay').forEach(function (overlay) {
      overlay.classList.remove('active-overlay');
    });
    clearStaleScrollLocks();
  }

  function scheduleClose() {
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(closeMobileSwatches, 0);
  }

  function scrollToProductImage() {
    clearStaleScrollLocks();
    var imageArea = document.querySelector('.product-img-box');
    if (!imageArea) return;

    var header = document.querySelector('.site-header');
    var headerHeight = header ? header.getBoundingClientRect().height : 0;
    var pageOffset = window.pageYOffset || document.documentElement.scrollTop || 0;
    var targetTop = Math.max(0, imageArea.getBoundingClientRect().top + pageOffset - headerHeight - 8);

    try {
      window.scrollTo({ top: targetTop, behavior: 'smooth' });
    } catch (error) {
      window.scrollTo(0, targetTop);
    }
  }

  function handleColorSelectorOpen(event) {
    if (!isMobileViewport() || !event.target.closest('#color_select')) return;
    window.clearTimeout(scrollTimer);
    scrollTimer = window.setTimeout(scrollToProductImage, 0);
  }

  function handleSwatchClose(event) {
    if (!isMobileViewport() || !event.target.closest('.close-swatch')) return;
    scheduleClose();
  }

  document.addEventListener('click', handleColorSelectorOpen, true);
  document.addEventListener('click', handleSwatchClose, true);
  window.addEventListener('pageshow', function () {
    if (isMobileViewport() && !document.querySelector('.product-shop .swatch.active-swatch')) {
      clearStaleScrollLocks();
    }
  });
})();
